<form class="expertise" [formGroup]="form" [class.not-active]="!expertise?.isActive">
  <div class="expertise-row type">
    <div class="number type__number" [class.error]="!expertiseType?.valid">{{numberCount}}.{{index}}</div>
    <div class="title">Тип экспертизы</div>
    <div class="main type-checkbox">
      <ng-container *ngIf="!id?.value; else expTitle">
        <label class="type-checkbox-item" *ngFor="let item of expertiseTypes; let index = index">
          <input type="radio" id="doc-type+{{ index }}" [value]="item.id" formControlName="expertiseType"/>
          {{item.title}}
        </label>
      </ng-container>
      <ng-template #expTitle>
        <div class="exp-title">
          {{expertise?.expertiseTypeTitle}}
          <ng-container *ngIf="expertiseType?.value === 1 && !isIntegration?.value">
            <app-object-notice [indicat]="'YELLOW'" [notice]="notificationText"></app-object-notice>
          </ng-container>
        </div>
      </ng-template>
    </div>
    <div class="status-checkbox" *ngIf="expertise.id">
      <app-status-check [isActive]="expertise.isActive"
                        [expertise]="expertise"
                        [livingComplexID]="objectId"
                        [regionID]="regionID"
                        (onChangeActive)="getActiveChanges($event, expertise)"
      ></app-status-check>
    </div>
    <div class="actions">
      <div class="action" matRipple (click)="remove()" *ngIf="expertise.id === null">
        <span class="icon-plus"></span>
      </div>
    </div>
  </div>

  <!--Номер и дата заключения-->
  <div class="expertise-row">
    <div class="number type__number" [class.error]="!documentNumber?.valid || !documentDate?.valid">{{numberCount}}.{{index}}.1</div>
    <div class="title">Номер и дата заключения</div>
    <div class="main">
      <div class="flex">
        <div class="flex">
          №
          <ng-container *ngIf="expertise?.isEdit;  else numberValue">
            <ng-container *ngIf="expertiseType?.value === 1;  else privType">
              <input class="my-input" type="text" mask="00-0000/00" [dropSpecialCharacters]="false"
                     [showMaskTyped]="true" formControlName="number">
            </ng-container>
            <ng-template #privType>
              <input class="my-input" type="text" formControlName="number">
            </ng-template>
          </ng-container>
          <ng-template #numberValue>
            <ng-container *ngIf="expertiseType?.value === 1;  else privTypeValue">
              <div
                class="number-value">{{documentNumber?.value ? (documentNumber?.value | mask: '00-0000/00') : '-'}}</div>
            </ng-container>
            <ng-template #privTypeValue>
              <div class="number-value">{{documentNumber?.value ? documentNumber?.value : '-'}}</div>
            </ng-template>
          </ng-template>
          <div class="action" matRipple (click)="expertise.isEdit = !expertise.isEdit" *ngIf="!expertise?.id || expertiseType?.value === 1">
            <div class="icon-edit"></div>
          </div>
        </div>
        <div class="flex ml">
          {{documentDate?.value ? ('от ' + (documentDate?.value | dateFormat: "1" | uppercase)) : 'Дата заключения'}}
          <div class="action" matRipple (click)="openCalendar()" *ngIf="!expertise?.id || expertiseType?.value === 1">
            <div class="icon-calendar"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="action"></div>
    </div>
  </div>

  <!--Данные о ЭЦП-->
  <!--<div class="expertise-row" *ngIf="expertiseType?.value === 1">
    <div class="number type__number" [class.error]="!sampleSignInfo && !sampleSignInfo?.notAfter">5.{{index}}.2</div>
    <div class="title">Данные о ЭЦП</div>
    <div class="main">{{sampleSignInfo?.text ? sampleSignInfo?.text : 'Отсутствует'}}</div>
    <div class="actions">
      <div *ngIf="!this.sampleSignInfo.bool" class="action" matRipple (click)="getSamplePdf()">
        <div class="icon-attach" >
          <img src="./assets/svg-icons/attach.svg" alt="icon-attach">
        </div>
      </div>
    </div>
  </div>-->

  <!--Файл согласия заказчика проекта-->
  <div class="expertise-row" *ngIf="expertiseType?.value === 1">
    <div class="number type__number" [class.error]="!expertise?.authorConsentFileInfo">{{numberCount}}.{{index}}.2</div>
    <div class="title">Файл согласия заказчика проекта</div>
    <div
      class="main">{{expertise?.authorConsentFileInfo ? expertise?.authorConsentFileInfo?.fileName : 'Файл не сформирован'}}</div>
    <div class="actions">
      <div class="action" matRipple *ngIf="!expertise?.authorConsentFileInfo?.fileID && (documentDate?.value && documentNumber?.value)">
        <div class="icon-attach" (click)="getConsentFormPdf()">
          <img src="./assets/svg-icons/attach.svg" alt="icon-attach">
        </div>
      </div>
      <div class="action" matRipple
           (click)="downloadFile(expertise?.authorConsentFileInfo?.fileID, expertise?.authorConsentFileInfo?.fileName)"
           *ngIf="expertise?.authorConsentFileInfo?.fileID">
        <div class="icon-download">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!--Запросить данные от РГП “Госэкспертиза”-->
  <div class="expertise-row" *ngIf="expertiseType?.value === 1 && !expertise?.conclusionFileInfo?.fileID">
    <button class="request-button" matRipple
            [class.disabled]="!expertise?.authorConsentFileInfo?.fileID"
            (click)="expertise?.authorConsentFileInfo?.fileID ? checkExpertise(): ''">
      <ng-container *ngIf="!checkLoader; else loading">
        <img src="./assets/images/icons/reload.svg" alt="reload-icon">
        {{expertise?.conclusionFileInfo?.fileID ? 'Обновить' : 'Запросить'}} данные от РГП “Госэкспертиза”
      </ng-container>
      <ng-template #loading>
        <div class="loading"></div>
      </ng-template>
    </button>
  </div>

  <!--Файл заключения экспертизы-->
  <div class="expertise-row" *ngIf="expertiseType?.value === 3 || expertise?.id || expertise?.conclusionFileInfo?.fileID">
    <div class="number type__number" [class.error]="!expertise?.conclusionFileInfo">{{numberCount}}.{{index}}.{{expertiseType?.value === 1 ? 3 : 2}}</div>
    <div class="title">Файл заключения экспертизы</div>
    <div class="main main-title">
      {{expertise?.conclusionFileInfo ? expertise?.conclusionFileInfo?.fileName : 'Файл отсутствует'}}
    </div>
    <div class="actions">
      <div class="action" matRipple [class.hidden]="expertiseType?.value === 1 || id?.value">
        <input #conclusionFile type="file" accept="application/pdf" (change)="onFileChange($event)"/>
        <div class="icon-attach" (click)="attachFile()">
          <img src="./assets/svg-icons/attach.svg" alt="icon-attach">
        </div>
      </div>
      <div class="action" matRipple
           (click)="downloadFile(expertise?.conclusionFileInfo?.fileID, expertise?.conclusionFileInfo?.fileName)"
           *ngIf="expertise?.conclusionFileInfo?.fileID">
        <div class="icon-download">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!--Частная экпертиза кнопка сохранить-->
  <div class="expertise-row" *ngIf="expertiseType?.value === 3 && form.dirty">
    <div class="title"></div>
    <div class="main">
      <button class="request-button private" matRipple
              [class.disabled]="!privateBtnEnable"
              (click)="privateBtnEnable ? savePrivateType() : ''">
        <ng-container *ngIf="!checkLoader; else loading">
          Сохранить
        </ng-container>
        <ng-template #loading>
          <div class="loading"></div>
        </ng-template>
      </button>
    </div>
  </div>
</form>


<app-modal-window
  class="modal-window"
  *ngIf="calendarModal"
  [visible]="calendarModal"
  [title]="'Календарь'"
  [width]="1300"
  [scrollbar]="false"
  (close)="calendarModal = $event"
>
  <app-calendar
    [inputDate]="transformDate(documentDate?.value)"
    (outputDate)="closeCalendar($event)"
  ></app-calendar>
</app-modal-window>
